import { Build, Component, Element } from '@stencil/core';
import { isBotRequest } from '~service/bot-service';

@Component({
  tag: 'staedtler-sticky-header',
})
export class StickyHeader {
  @Element()
  el!: HTMLElement;

  observer?: IntersectionObserver;

  async componentDidLoad() {
    if (isBotRequest() || !Build.isBrowser) {
      return;
    }
    if (!document.getElementById('content')) {
      return;
    }
    const body = document.querySelector('body');
    if ((window.pageYOffset || document.documentElement.scrollTop) > 75) {
      body.classList.add('disable-animation');
    }
    this.observer = new IntersectionObserver(
      changes => {
        changes.forEach(entry => {
          if (entry.isIntersecting) {
            body.classList.remove('header-small');
          } else {
            body.classList.add('header-small');
          }
          setTimeout(() => body.classList.remove('disable-animation'));
        });
      },
      { rootMargin: '-75px 0px' },
    );
    this.observer.observe(document.getElementById('content'));
  }
}
